// src/mobile_pages/approval/Docs_view.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { FileText, ClipboardList } from "lucide-react";
import MobileFormViewManager from "../../components/common/mobile/MobileFormViewManager";

export default function Docs_view() {
  const { id: projectId, dns, type } = useParams();

  return (
    <MobileFormViewManager
      params={{
        project: projectId,
        dns,
        module: "approval",
        doc_type: type || "APP",
      }}
      doc_name="결재 문서"
    >
      {/* MobileFormViewManager가 children으로 본문 렌더링 */}
      <ApprovalDocBody />
    </MobileFormViewManager>
  );
}

/* 결재문서 본문 내용 렌더링 */
function ApprovalDocBody({ meta, data }) {
  const content = meta?.content || data?.meta?.content || data?.content || "";
  const docType = data?.doc_type || data?.meta?.doc_type || "-";

  return (
    <div className="space-y-4">
      {/* 문서유형 카드 */}
      <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
        <div className="px-4 py-3 bg-slate-50 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <ClipboardList size={16} className="text-slate-500" />
            <h3 className="text-sm font-semibold text-slate-700">문서 정보</h3>
          </div>
        </div>
        <div className="p-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
              <FileText size={16} className="text-blue-500" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-slate-400 mb-0.5">문서유형</p>
              <p className="text-sm text-slate-900 font-medium">{docType}</p>
            </div>
          </div>
        </div>
      </div>

      {/* 본문 내용 카드 */}
      <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
        <div className="px-4 py-3 bg-slate-50 border-b border-slate-200">
          <h3 className="text-sm font-semibold text-slate-700">본문 내용</h3>
        </div>
        {content ? (
          <div className="p-4">
            <div
              className="prose prose-sm max-w-none text-slate-700 break-words"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        ) : (
          <div className="p-6 text-center">
            <p className="text-sm text-slate-400">내용이 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
}
